import { Agent } from "@/api/generated";

// プランナーの表示名。姓・名は片方欠けることがあるため空文字で連結する。
// 相性プランナー系カード（診断結果画面・ホーム）で共通に使う。表示規則を変えるときはここだけ直す。
export const buildAgentName = (agent: Agent): string => `${agent.family_name ?? ""}${agent.first_name ?? ""}`;
